<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div ref="search_form"></div>

    <!-- 버튼 -->
    <div ref="buttons"></div>

    <!-- 공지사항 -->
    <div class="noti_div" :style="{ height: tableHeight + 'px' }">
      <el-collapse v-model="collapse_val" v-for="(noti, index) in tableData" :key="'noti_' + index" accordion>
        <el-collapse-item :name="index">
          <template slot="title">
            <el-badge value="new" v-if="isNew(noti.startDtm)">
              <div class="noti-title">{{ '[ ' + noti.startDtm + ' ] ' + noti.notiTitle }}</div>
            </el-badge>

            <div class="noti-title" v-else>{{ '[ ' + noti.startDtm + ' ] ' + noti.notiTitle }}</div>
          </template>
          <div v-html="noti.content.replace(/\n/gm, '<br/>')" class="noti-content"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { initData } from '@/utils/constants'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/noti'

    data.collapse_val = 0

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url + '/showNotiList',
        null,
        function (result) {
          this.tableData = result
        }.bind(this),
        false
      )
    },
  },
}
</script>

<style scoped>
.noti_div {
  padding: 20px;
  border-top: 1px solid #dadde4;
  overflow: auto;
}

.el-collapse {
  border-top: none;
}

.el-collapse-item__header.is-active {
  border-bottom: 1px solid #dadde4;
}

.noti-title {
  display: flex;
  align-items: center;

  width: 100%;
  padding: 0 20px;

  line-height: 1;
}

.noti-content {
  padding: 20px 40px;
}

.el-badge__content.is-fixed {
  top: 24px;
}

@media (max-width: 768px) {
  .noti_div {
    padding: 0;
  }
  .noti-title {
    height: 100%;
    padding: 10px 5px;
    font-size: 12px;
  }
  .noti-content {
    padding: 10px;
  }
}
</style>
